import classnames from 'classnames'
import React from 'react'
import { Row, Col } from '../'
import './index.less'

const clsPrefix = 'tnt-columns'

export const Item = (props) => {
  const {
    children,
    span,
    extra,
    title,
    tabList,
    defaultActiveTabKey,
    activeTabKey,
    tabType,
    onTabChange,
  } = props
  const realActiveKey = activeTabKey || defaultActiveTabKey

  return (
    <Col className={`${clsPrefix}-col`} span={span < 4 ? 4 : span}>
      <div>
        {(!tabList || tabList.length < 0) && (
          <div className={`${clsPrefix}-col-header`}>
            <div className="title-left">{title}</div>
            {extra && <div className="title-extra">{extra}</div>}
          </div>
        )}
        {tabList?.length > 0 && (
          <div className={`${clsPrefix}-col-tabs`} tabType={tabType} tabList={tabList}>
            {tabList.map(({ tab, key }) => (
              <span
                className={classnames('tab-item', {
                  'active-tab': realActiveKey === key,
                })}
                style={{
                  width: tabList && tabType === 'default' ? 'auto' : `${100 / tabList.length}%`,
                }}
                key={key}
                onClick={() => onTabChange(key)}
              >
                {tab}
              </span>
            ))}
          </div>
        )}
        <div className={`${clsPrefix}-col-body`}>{children}</div>
      </div>
    </Col>
  )
}

const Columns = (props) => {
  const { children, height, gutter = 0, style, ...rest } = props
  const rowStyle = {
    ...style,
    height: props.height ? `${props.height}px` : 'calc(100vh)',
  }

  return (
    <Row className={classnames(clsPrefix, { gutter })} style={rowStyle} {...rest}>
      {children}
    </Row>
  )
}
Columns.Item = Item

export default Columns
